import { callApi } from './common'

function projects(id) {
  return callApi(`billing/account/${id}/projects`, {})
}

function hasAccountSecret(id) {
  return callApi(`billing/account/${id}/secret`, {})
}

function getAccountCorporation(id) {
  return callApi(`billing/account/${id}/corporation`, {})
}

export default {
  projects,
  hasAccountSecret,
  getAccountCorporation,
}
